import {createAction, createReducer} from '@reduxjs/toolkit';

export const initialState = Date.now() / 1000 + 300;

/**
 * Set upsell timer to now
 * @returns {ActionType} action
 */
export const setUpsellTimer = createAction('SUCCESS_PAGE@SET_UPSELL_TIMER');

/**
 * Set upsell timer to new value
 * @param {number} state - Reducer state
 * @return {number} New reducer state
 */
export const upsellTimer = createReducer<number>(initialState, builder => {
    builder.addCase(setUpsellTimer, () => Date.now() / 1000 + 300);
});
